const target = new URL('https://radar-b3-30d6d.web.app');
target.pathname = window.location.pathname;
target.search = window.location.search;
target.hash = window.location.hash;
window.location.replace(target.toString());
